import React from 'react';

export default function Govigivisum({ onBackClick }) {
  const handleBack = () => {
    if (onBackClick) {
      onBackClick('agripaper');
    }
  };

  const [selectedPdf, setSelectedPdf] = React.useState(null);
  const pdfViewerRef = React.useRef(null);

  React.useEffect(() => {
    if (selectedPdf !== null && pdfViewerRef.current) {
      setTimeout(() => {
        pdfViewerRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
    }
  }, [selectedPdf]);

  const pdfList = [
    { name: 'ගොවි ගිවිසුම් පත්‍රය', file: '/downloads/ගොවි ගිවිසුම් පත්‍රය.pdf' },
  ];

  return (
    <section className="agripaper-section" aria-label="Govi Giwisum">
      <div className="agripaper-header">
        <button
          className="back-button"
          onClick={handleBack}
          style={{
            backgroundColor: '#0b6b2f',
            color: 'white',
            border: 'none',
            padding: '8px 16px',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '14px',
            marginBottom: '12px',
            display: 'flex',
            alignItems: 'center',
            gap: '6px'
          }}
        >
          ← ආපසු
        </button>
        <h1 style={{ color: '#0b6b2f', fontSize: 28, marginBottom: 12 }}>ගොවි ගිවිසුම් පත්‍ර</h1>
        <hr className="footer-sep" />
      </div>

      <div style={{ padding: '20px', maxWidth: '1000px', margin: '0 auto' }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: '20px',
          marginBottom: '30px'
        }}>
          {pdfList.map((pdf, index) => (
            <div
              key={index}
              style={{
                border: '1px solid #ddd',
                borderRadius: '12px',
                padding: '24px',
                backgroundColor: '#f9f9f9',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                textAlign: 'center'
              }}
            >
              <h3 style={{ color: '#0b6b2f', marginBottom: '20px', fontSize: '18px' }}>{pdf.name}</h3>
              <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap' }}>
                <a
                  href={pdf.file}
                  download
                  style={{
                    backgroundColor: '#0b6b2f',
                    color: 'white',
                    padding: '8px 16px',
                    borderRadius: '4px',
                    textDecoration: 'none',
                    fontWeight: 'bold',
                    fontSize: '14px'
                  }}
                >
                  📥 Download
                </a>
                <button
                  onClick={() => setSelectedPdf(selectedPdf === index ? null : index)}
                  style={{
                    backgroundColor: '#4CAF50',
                    color: 'white',
                    padding: '8px 16px',
                    borderRadius: '4px',
                    border: 'none',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    fontSize: '14px'
                  }}
                >
                  👁️ View
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* PDF Viewer Section with Auto-Scroll Ref */}
        {selectedPdf !== null && (
          <div 
            ref={pdfViewerRef}
            style={{
              border: '1px solid #ddd',
              borderRadius: '8px',
              padding: '20px',
              backgroundColor: '#f9f9f9',
              marginBottom: '20px'
            }}
          >
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '16px'
            }}>
              <h2 style={{ color: '#0b6b2f', margin: 0 }}>{pdfList[selectedPdf].name}</h2>
              <button
                onClick={() => setSelectedPdf(null)}
                style={{
                  backgroundColor: '#f44336',
                  color: 'white',
                  border: 'none',
                  padding: '8px 16px',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontWeight: 'bold'
                }}
              >
                ✕ Close
              </button>
            </div>
            <div style={{
              width: '100%',
              height: '700px',
              border: '1px solid #ccc',
              borderRadius: '4px',
              overflow: 'hidden',
              backgroundColor: '#fff'
            }}>
              <iframe
                src={pdfList[selectedPdf].file}
                style={{ width: '100%', height: '100%', border: 'none' }}
                title="Agreement Viewer"
              />
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
